'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _seller = require('./remote/seller');

var Seller = {
    fetchSellers: function fetchSellers(params) {
        return _seller.SellerRemote.fetchSellers(params);
    },
    fetchSellersByIds: function fetchSellersByIds(params) {
        return _seller.SellerRemote.fetchSellersByIds(params);
    },
    postFollow: function postFollow(params) {
        return _seller.SellerRemote.postFollow(params);
    },
    postMessage: function postMessage(params) {
        return _seller.SellerRemote.postMessage(params);
    },
    postUnfollow: function postUnfollow(params) {
        return _seller.SellerRemote.postUnfollow(params);
    }
};

exports.default = Seller;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/seller.js
// module id = yM+3
// module chunks = 46